// extracted by mini-css-extract-plugin
module.exports = {"container":"e_MA","msrp":"e_NA","save":"e_OA","discount":"e_PA","price":"e_QA"};